export default __webpack_public_path__ + "static/media/IRIS-logo-Transprenet-white.8125d594.png";